// Lightweight internal analytics. Batched, anonymous (device-ID only), and
// deduped so polling/rerenders can never spam the same event.

import { api } from "./api";

const FLUSH_MS = 5000;
const DEDUPE_MS = 2000;

let queue = [];
let timer = null;
const lastSent = new Map();

function flush() {
  timer = null;
  if (!queue.length) return;
  const events = queue.slice(0, 50);
  queue = queue.slice(50);
  api.post("/analytics", { events }).catch(() => {});
  if (queue.length) schedule();
}

function schedule() {
  if (timer) return;
  timer = setTimeout(flush, FLUSH_MS);
}

/** track("map_layer_activated", { layer: "free_parking" }) */
export function track(event, props) {
  const key = `${event}:${JSON.stringify(props || {})}`;
  const now = Date.now();
  if (now - (lastSent.get(key) || 0) < DEDUPE_MS) return;
  lastSent.set(key, now);
  queue.push({ event, props: props || {}, ts: new Date().toISOString() });
  schedule();
}

if (typeof window !== "undefined") {
  window.addEventListener("pagehide", flush);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
}
